export const TABLE_TYPE = "table";
export const TABLE_ROW_TYPE = "table-row";
export const TABLE_CELL_TYPE = "table-cell";
